import { defineAction } from '~/prix'
import pointOfInterestDeleteAction from './pointOfInterestDelete.action.json' assert { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const pointOfInterestDeleteDefinition = defineAction({
  ...pointOfInterestDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default pointOfInterestDeleteDefinition
